module.exports = __webpack_public_path__ + "static/media/alert_info.52ef3792.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/alert_info.svg
// module id = 818
// module chunks = 0